import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SERVICE_REQUEST_ACTIONS } from '@usf/ngrx-list';
import { tap } from 'rxjs/operators';
import { ServiceRequestService } from '@service-request/services/service-request.service';

@Injectable({
  providedIn: 'root',
})
export class ClientRequestCreditEffects {
  constructor(
    private actions$: Actions,
    private serviceRequestService: ServiceRequestService,
  ) {}

  serviceRequestSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SERVICE_REQUEST_ACTIONS.submitRequestCreditSuccess),
        tap(action => {
          const trackingData = {
            orderId: action.trackingData.orderId,
            hasPhoto: action.trackingData?.hasPhoto,
            productData: action.trackingData?.productData,
          };
        }),
      ),
    { dispatch: false },
  );
}
